import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SecuredResourceComponent } from '@app/shared/secured-resource/secured-resource.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SecuredResourceComponent],
  imports: [CommonModule, MatProgressBarModule, MatProgressSpinner],
  exports: [SecuredResourceComponent],
})
export class SecuredResourceModule {}
